import { FC } from 'react';
import { tw } from 'utils/tailwindUtils';
import Chip, { ChipModel } from './Chip';

interface FilterChipsBarProps {
  chips: ChipModel[];
  className?: string;
}

/**
 * Barra genérica de chips de filtros activos con el estilo estándar (`Chip`).
 * Cada módulo arma su lista de `ChipModel` según sus propios filtros y la
 * pasa acá; no renderiza nada si no hay chips.
 */
const FilterChipsBar: FC<FilterChipsBarProps> = ({ chips, className }) => {
  if (chips.length === 0) {
    return null;
  }

  return (
    <div className={tw('flex flex-wrap items-center gap-2', className)}>
      {chips.map((chip, index) => (
        <Chip key={index} chip={chip} />
      ))}
    </div>
  );
};

export default FilterChipsBar;
